import { CritrereNombreDecimalController } from './critere.nombre.decimal.controller';

export default {
    bindings: {
        critere: '='
    },
    controller: CritrereNombreDecimalController,
    template: require('./critere.nombre.decimal.tpl.html')
};
